import { MapPin, Handshake } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BringTraditionToYourTable() {
  return <section data-section-id="243441" id="دعوت-به-تغییر" className="dark bg-background text-foreground py-24 sm:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-10 pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684933/img/wavy_pattern_texture.png')] bg-repeat"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center flex flex-col items-center">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-balance text-foreground">
            آماده‌اید سفر بهبودی خود را آغاز کنید؟
          </h2>
          
          <p className="text-lg md:text-xl text-foreground/80 mb-10 max-w-2xl text-balance font-default">
            دکتر مهرنوش اسماعیلی با بیش از ۱۰ سال تجربه بالینی، در مسیر مدیریت اضطراب، افسردگی و بهبود روابط در کنار شماست.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
            <Button asChild size="lg" className="w-full sm:w-auto text-base h-14 px-8 rounded-lg shadow-lg hover:shadow-xl transition-all bg-secondary text-secondary-foreground hover:opacity-90 font-default">
              <Link to="/BookAppointmentPage">
                <MapPin className="mr-2 size-5" />
                رزرو نوبت مشاوره اولیه
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base h-14 px-8 rounded-lg border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground bg-transparent transition-all font-default">
              <Link to="/ContactUsPage">
                <Handshake className="mr-2 size-5" />
                ارتباط مستقیم با ما
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}